import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useQuery } from '@tanstack/react-query';

export const PART_FINDER_REPORT_QUERY_KEY = 'partFinderReport';

export const useGetPartFinderReport = (id: string) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  return useQuery({
    queryKey: [PART_FINDER_REPORT_QUERY_KEY, id],
    queryFn: async () => {
      const response = await api.tenants.getPartFinderReport(tenantId, id);
      return response.data.partFinderReport;
    },
    enabled: !!id && !!tenantId,
  });
};
